import React from 'react';
import { MailIcon } from 'lucide-react';
export function Footer() {
  return <footer className="bg-plum text-white" data-id="element-53" data-mp="3gf958x4mo89h">
      <div className="mx-auto max-w-4xl px-5 py-12 text-center" style={{
      paddingTop: "25px"
    }} data-id="element-54" data-mp="3gg10g6ubc3z8">
        <p className="font-display text-xl font-black text-white" data-id="element-55" data-mp="32p5qssbzpiul">
          SIGMA SMART<span className="align-super text-xs" data-id="element-56" data-mp="36oo5359b2vog">™</span> — 100+ TAKTİK RAPOR YAPAY ZEKÂ KOMUTU<span className="align-super text-xs" data-id="element-57" data-mp="3ueiknul0eyce">™</span>
        </p>

        <p className="mt-4 font-display text-base font-semibold italic text-grape-soft" data-id="element-58" data-mp="3ud7g3sjqpmk8">
          🏥 Daha düzenli raporlama. Daha yapılandırılmış belge hazırlığı. Daha sistematik bir çalışma süreci.
        </p>

        <div className="mt-8 flex flex-wrap items-center justify-center gap-x-6 gap-y-3 text-sm text-white/75" data-id="element-59" data-mp="3qdf2h1fhoq80">
          <a href="mailto:soporte.sigmasmart@gmail.com" className="inline-flex items-center gap-2 transition-colors duration-150 ease-out hover:text-white" data-id="element-60" data-mp="29zgnu9fpz8qc">
            <MailIcon className="h-4 w-4 text-blush" data-id="element-61" data-mp="2ezl0fodibjba" /> soporte.sigmasmart@gmail.com
          </a>
        </div>

        <div className="mt-8 flex flex-wrap justify-center gap-x-4 gap-y-2 text-xs text-white/55" data-id="element-62" data-mp="3lbddywk4gfne">
          <a href="#" className="transition-colors duration-150 ease-out hover:text-white" data-id="element-63" data-mp="3gctq2qlywtse">
            Şartlar ve Koşullar
          </a>
          <span data-id="element-64" data-mp="3q8dkf8kvvkf1">·</span>
          <a href="#" className="transition-colors duration-150 ease-out hover:text-white" data-id="element-65" data-mp="3q7u2hrv8gw10">
            Gizlilik Politikası
          </a>
          <span data-id="element-66" data-mp="80ntqkb6ysde">·</span>
          <a href="#" className="transition-colors duration-150 ease-out hover:text-white" data-id="element-67" data-mp="3477jvnjyo2y">
            Destek
          </a>
        </div>

        <p className="mt-8 text-xs leading-relaxed text-white/45" data-id="element-68" data-mp="hriipwfto62j">
          © 2026 SIGMA SMART™ — Tüm hakları saklıdır.
        </p>
      </div>
    </footer>;
}